import * as React from 'react';
import { useStyles } from '../styles';
import { Button } from '@/components';
import { inIframe } from '@/utils';
import { useNavigate } from 'react-router-dom';
import { trackPageView } from '@/gtag/utils';

export const HomeNavButtons = () => {
  const isInIframe = inIframe();
  const styles = useStyles({ isInIframe });
  const navigate = useNavigate();
  return (
    <div className={styles.buttons}>
      <Button
        onClick={() => {
          navigate('/createCustomer');
          trackPageView('/createCustomer', 'Sign up');
        }}
        className={styles.button}
        text="Sign up"
        size="large"
      />
      <Button
        onClick={() => {
          navigate('/search');
          trackPageView('/search', 'Search customer');
        }}
        className={styles.button}
        text="Search customer"
        size="large"
      />
    </div>
  );
};
